import { ClockStatus } from './databaseModels';
import { NoShowAssessment, noShowAssessmentLabels } from './noShow';

/**
 * Status column text of a clock: "Niet gewerkt – {assessment}" for a no-show (e.g. "Niet gewerkt – Geoorloofd"),
 * otherwise the process status
 */
export const clockStatusText = (
    clockStatus: ClockStatus,
    noShowAssessment: NoShowAssessment | null,
    processStatus: string,
): string => {
    if (clockStatus !== ClockStatus.NoShow) {
        return processStatus;
    }
    return noShowAssessment != null
        ? `Niet gewerkt – ${noShowAssessmentLabels[noShowAssessment]}`
        : 'Niet gewerkt';
};
